import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ActionKeys } from '../../Forms/enums/keys.enum';

@Directive({
    selector: '[agprOverlayTrigger]',
    exportAs: 'agprOverlayTrigger',
    standalone: false
})
export class OverlayTriggerDirective {
    @Output() triggerClick = new EventEmitter<void>(); // open, clase
    @Output() closeOverlay = new EventEmitter<void>();

    constructor(public el: ElementRef) {}

    @HostListener('click')
    onClick() {
        this.triggerClick.emit();
    }

    @HostListener('keydown', ['$event'])
    onKeydown(event: Event) {
        const keyboardEvent = event as KeyboardEvent;
        if (keyboardEvent.key === ActionKeys.ENTER || keyboardEvent.key === ActionKeys.SPACE) {
            event.preventDefault();
            this.triggerClick.emit();
        }
    }

    ngOnDestroy() {
        this.closeOverlay.emit();
    }
}
